import Image from 'next/image';
import { Box } from '@mui/material';

import vegan from '@public/assets/png/vegan.png';

export const GetVegan = () => {
  return (
    <Box
      sx={{
        display: 'inline-block',
        position: 'relative',
        height: '26px',
        width: '20px',
      }}
    >
      <Image
        src={vegan}
        alt="vegan"
        objectFit="contain"
        layout="fill"
      />
    </Box>
  );
};
